export class Progress {
    private property: string = '--progress';
    private trigger: any;
    private lastProgress: number = -1;

    constructor(private element: HTMLElement) {
        this.init();
    }

    private init(): void {
        const attr = this.element.getAttribute('data-progress');
        if (!attr) return;

        const data = attr.split('|');
        const name = data[0] || null;
        const start = data[1] || "top bottom";
        const end = data[2] || "bottom top";
        this.property = name ? `--progress-${name.toLowerCase().replace(' ', '_')}` : '--progress';

        this.element.style.setProperty(this.property, '0');
        this.createTrigger(start, end);
    }

    private createTrigger(start: string, end: string): void {
        this.trigger = window.scrollTrigger.create({
            trigger: this.element,
            start,
            end,
            scrub: true,
            fastScrollEnd: true,
            markers: false,
            onUpdate: (self) => this.updateProgress(self.progress),
        });

        if (this.trigger.progress > 0) {
            this.updateProgress(this.trigger.progress);
        }
    }

    private updateProgress(value: number): void {
        const clampedValue = Math.round(value * 100000) / 100000;

        if (Math.abs(this.lastProgress - clampedValue) > 0.00001) {
            this.lastProgress = clampedValue;
            this.element.style.setProperty(this.property, clampedValue.toString());
        }
    }

    destroy(): void {
        this.trigger?.kill();
    }
}
